import React from 'react';

import XMarkIcon from 'buyside/svgs/x_mark.svg';

import styles from './chipStyles.scss';

interface IProps {
  label: string;
  value: string;
  handleRemove: () => void;
}

const Chip: React.FC<IProps> = ({ label, value, handleRemove }): React.ReactElement => {
  return (
    <div className={styles.container}>
      <div className={styles.labelValueContainer}>
        <span className={styles.label}>{label}:</span>

        {Boolean(value.length) && <span className={styles.value}>{value}</span>}
      </div>

      <XMarkIcon className={styles.icon} onClick={handleRemove} data-heap="remove-chip" />
    </div>
  );
};

export default Chip;
